var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M22.84,17.83a.51.51,0,0,1-.71,0L12.51,8.21,2.87,17.85a.51.51,0,0,1-.36.15.5.5,0,0,1-.35-.85l10-10a.5.5,0,0,1,.71,0l10,10A.5.5,0,0,1,22.84,17.83Z"})));
}

ChevronUp.defaultProps = {"viewBox":"0 0 25 31.25","x":"0px","y":"0px","width":"32","height":"32"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
